<template>
<div>
    <section>
        <div class="div-block-2176">
            <a href="#" class="w-inline-block"><img loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" class="image-654"></a>
        </div>
    </section>
    <section v-if="pageEl==1">
        <div class="reviewsection_wrap">
            <div class="review_maindiv">
                <div class="review_div" v-if="active_el===1">
                    <div class="text-block-1614">How would you rate your experience?</div>
                    <div class="w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="690ae954c1397a30fda48468" data-wf-element-id="d7aa2416-81ff-bef6-c9bb-7ae7d757adaf">
                            <div class="form-links-div">
                                <a href="#" @click="handleBadRating($event, 1)" class="option-link w-inline-block">
                                    <div class="option-img-div"><img src="https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/images/icon_rating_verysad1.svg" loading="lazy" alt="" class="image-655"></div>
                                </a>
                                <a href="#" @click="handleBadRating($event, 2)" class="option-link w-inline-block">
                                    <div class="option-img-div"><img src="https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/images/icon_rating_sad1.svg" loading="lazy" alt="" class="image-655"></div>
                                </a>
                                <a href="#" @click="moveToNextSection($event)" class="option-link w-inline-block">
                                    <div class="option-img-div"><img src="https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/images/icon_rating_happy1.svg" loading="lazy" alt="" class="image-655"></div>
                                </a>
                                <a href="#" @click="moveToNextSection($event)" class="option-link w-inline-block">
                                    <div class="option-img-div"><img src="https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/images/icon_rating_veryhappy1.svg" loading="lazy" alt="" class="image-655"></div>
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="review_div" v-if="active_el===2">
                    <div class="text-block-1614 with-sub">Your Experience Matters to Us</div>
                    <p class="paragraph-209">We read every submission personally. Let us know what didn't meet your expectations so we can improve and fix it.</p>
                    <div class="w-form">
                        <form id="email-form" class="form-23" @submit.prevent="moveToNext">
                            <textarea placeholder="Please leave your review here" v-model="reviewText" maxlength="5000" id="field" name="field" data-name="Field" class="textarea-5 w-input"></textarea>
                            <input type="submit" data-wait="Please wait..." class="review-form-button w-button" value="Next -&gt;">
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="review_div" v-if="active_el===3">
                    <div class="text-block-1614">Did we resolve your issue?</div>
                    <div class="w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-22" data-wf-page-id="690ae954c1397a30fda48468" data-wf-element-id="372c11eb-c309-6874-788e-4ee05455696e">
                            <div class="review-text-links-div">
                                <a href="#" @click="handleResolution($event, true)" class="link-block-106 w-inline-block">
                                    <div>Yes</div>
                                </a>
                                <a href="#" @click="handleResolution($event, false)" class="link-block-106 w-inline-block">
                                    <div>No</div>
                                </a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section  v-if="pageEl==2">
        <div class="reviewsection_wrap">
            <div class="review_maindiv">
                <div class="review_div">
                    <div class="text-block-1614-copy with-sub">Can You Help us, {{name}} for 2 Minutes?</div>
                    <p class="paragraph-209-copy">We try to keep our pricing fair and transparent — but there are <strong>bad actors</strong> in this space who can’t match our pricing, so they post <strong>fake negative reviews</strong> to scare patients away. That can drive up costs for everyone.<br><br>So we ask our real patients to share their <strong>honest experience</strong>.<br><br>It only takes <strong>2 minutes</strong> and really helps.</p>
                    <div class="text-block-1614-copy2">When you leave an honest Trustpilot review:</div>
                    <div class="review_bullets-wrap">
                        <div class="review-bullets-div">
                            <div class="review-bullet"><img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-658">
                                <div class="text-block-1622"><strong>You’re entered into our monthly giveaway</strong> for trips, gear, and exclusive promos.</div>
                            </div>
                            <div class="review-bullet"><img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-658">
                                <div class="text-block-1622"><strong>One review = lifetime entry</strong> (you’re in every drawing moving forward).</div>
                            </div>
                            <div class="review-bullet"><img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-658">
                                <div class="text-block-1622"><strong>You’re entered into our monthly giveaway</strong> for trips, gear, and exclusive promos.</div>
                            </div>
                        </div>
                    </div>
                    <a href="#" @click="handleHappyRating($event, 5)" class="button-168 w-button">Click Here to Leave a Review <span class="text-span-402">-&gt;</span></a>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import axios from 'axios';
import {
    mapGetters
} from 'vuex';
export default {
    name: 'reviewPage',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            active_el: 1,
            reviewText: "",
            resolvedIssue: false,
            userId: null,
            selectedRating: null,
            pageEl: 1
        }
    },
    async mounted() {
        // Get userId from route params or query
        this.userId = this.$route.params.userId || this.$route.query.userId;
    },
    computed: {
        ...mapGetters(['user']),
        name() {
            try {
                return this.user.first_name;
            } catch (error) {
                console.log(error);
                return "";
            }
        },
    },
    methods: {
        moveToNextSection(event) {
            event.preventDefault();
            this.pageEl ++;
        },
        handleBadRating(event, rate) {
            event.preventDefault();
            this.selectedRating = rate;
            this.active_el++;
        },
        async moveToNext(event) {
            event.preventDefault();
            // Move to the next step (from step 2 to step 3)
            this.active_el++;
        },
        async handleResolution(event, resolved) {
            event.preventDefault();
            this.resolvedIssue = resolved;
            // Submit the bad review after user answers if issue was resolved
            await this.submitBadReview();
        },
        async submitBadReview() {
            try {
                // Submit the bad review to the API
                const response = await axios.post(`${this.baseUrl}/api/submit-review`, {
                    user_id: this.userId,
                    rating: this.selectedRating,
                    review: this.reviewText,
                    resolved: this.resolvedIssue
                });
                // Check if submission was successful
                if (response.data.success) {
                    // Redirect to the thank you (bad) page
                    this.$router.push('/feedback-thanks');
                } else {
                    this.$router.push('/feedback-thanks');
                    console.error('Failed to submit review:', response.data);
                }
            } catch (error) {
                console.error('Error submitting review:', error);
                // Optionally show an error message to the user
            }
        },
        async handleHappyRating(event, rate) {
            event.preventDefault();

            try {
                // Make GET request to fetch redirect URL
                const response = await axios.get(`${this.baseUrl}/api/rating-redirect`, {
                    params: {
                        userId: this.userId,
                        rate: rate,
                        sendSms: false
                    }
                });

                // Check if request was successful
                if (response.data.status === 'success' && response.data.reviewLink) {
                    // Redirect to the review link
                    window.location.href = response.data.reviewLink;
                } else {
                    console.error('Failed to get redirect URL:', response.data);
                }
            } catch (error) {
                console.error('Error fetching redirect URL:', error);
                // Optionally show an error message to the user
            }
        }
    },
    watch: {}
}
</script>
